export default __webpack_public_path__ + "static/media/174.c0c8e98a.svg";